import { render, staticRenderFns } from "./Accordion.vue?vue&type=template&id=7257fa8e&scoped=true&"
import script from "./Accordion.vue?vue&type=script&lang=js&"
export * from "./Accordion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7257fa8e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7257fa8e')) {
      api.createRecord('7257fa8e', component.options)
    } else {
      api.reload('7257fa8e', component.options)
    }
    module.hot.accept("./Accordion.vue?vue&type=template&id=7257fa8e&scoped=true&", function () {
      api.rerender('7257fa8e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-8w1RpJwLpr5Np/JS/comp/Accordion.vue"
export default component.exports